import BaseRepository from "./BaseRepository";
import st from "lib/utils/index";

export default new (class AffiliateRepository extends BaseRepository {
  searchOrders(params = {}) {
    return this.api.post(`/affiliate/search_orders`, params).map(({ data: { records, aggregations, meta } }) => ({
      records: st.api.dejsonapinize(records.data, records.included),
      aggregations,
      meta,
    }));
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/AffiliateRepository.js